import { Component, ViewChild } from '@angular/core';
import { ComboService } from '../Model/Combo/combo.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CommonService } from '../Model/Common/common.service';
import { ModuleService } from '../Model/Module/module.service';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-module-lock',
  standalone: true,
  imports: [NgSelectModule, CommonModule, FormsModule, NgbModule, LoaderComponent, DataTablesModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './module-lock.component.html',
  styleUrl: './module-lock.component.scss'
})
export class ModuleLockComponent {

  isDisabled: boolean = false;
  ModuleLoad = [] as any;
  TableData = [] as any;

  Filter = {
    SelectType: 'I',
    ESS_ModuleLockConfigurationId: 0,
    WEBESSModuleMasterId: null as any,
    FromDate: null as any,
    ToDate: null as any,
    IsRestrictedForAdmin: false,
    Message: ''
  }

  constructor(
    private dateFormat: CustomDateParserFormatter,
    public common: CommonService,
    private module: ModuleService,
    private modalService: NgbModal
  ) {
    this.dtoptions = { ...this.common.commonDToptions };
  }

  dtoptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  ngOnInit() {
    this.GetModule();
    // this.ESS_ModuleLockConfigurationSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Save(form: any) {
    if (form.valid) {
      this.ESS_ModuleLockConfigurationInsert();
    } else {
      form.submitted = true;
    }
  }

  ESS_ModuleLockConfigurationSelect(WEBESSModuleMasterId: any) {
    if (WEBESSModuleMasterId == null) {
      this.TableData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      return;
    }
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.Message = '';
    this.Filter.IsRestrictedForAdmin = false;
    this.Filter.ESS_ModuleLockConfigurationId = 0;
    this.isDisabled = true;
    this.module.ESS_ModuleLockConfigurationSelect({
      SelectType: 'S',
      ESS_ModuleLockConfigurationId: 0,
      WEBESSModuleMasterId: WEBESSModuleMasterId,
    }).subscribe({
      next: (response) => {
        this.TableData = response.ESSModuleLockConfiguration;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_ModuleLockConfigurationInsert() {
    this.isDisabled = true;
    this.Filter.SelectType = this.Filter.ESS_ModuleLockConfigurationId > 0 ? 'U' : 'I'
    this.module.ESS_ModuleLockConfiguration_InsertUpdate({
      SelectType: this.Filter.SelectType,
      ESS_ModuleLockConfigurationId: this.Filter.ESS_ModuleLockConfigurationId,
      WEBESSModuleMasterId: this.Filter.WEBESSModuleMasterId,
      FromDate: this.dateFormat.format(this.Filter.FromDate),
      ToDate: this.dateFormat.format(this.Filter.ToDate),
      IsRestrictedForAdmin: this.Filter.IsRestrictedForAdmin,
      Message: this.Filter.Message
    }).subscribe({
      next: (response) => {
        this.isDisabled = false;
        if (response.Error_Code == '985' || response.Error_Code == '986') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.ESS_ModuleLockConfigurationSelect(this.Filter.WEBESSModuleMasterId);
            }
          });
        } else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Delete(row: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you sure want to Delete?'
    modalRef.result.then((result: any) => {
      if (result) {
        this.ESS_ModuleLockConfigurationDelete(row);
      }
    }).catch(() => {

    });
  }

  ESS_ModuleLockConfigurationDelete(row: any) {
    this.isDisabled = true;
    console.log(row);
    this.module.ESS_ModuleLockConfiguration_InsertUpdate({
      SelectType: 'D',
      ESS_ModuleLockConfigurationId: row.ESS_ModuleLockConfigurationID,
      WEBESSModuleMasterId: row.WEBESSModuleMasterId,
      FromDate: row.FromDate,
      ToDate: row.ToDate,
      IsRestrictedForAdmin: row.IsRestrictedForAdmin,
      Message: row.Message
    }).subscribe({
      next: (response) => {
        if (response.Error_Code == '987') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.ESS_ModuleLockConfigurationSelect(this.Filter.WEBESSModuleMasterId);
            }
          });
        } else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetModule() {
    this.isDisabled = true;
    this.module.GetModule({ SelectType: 'ML', WebESSModuleMasterID: 0 }).subscribe({
      next: (response) => {
        this.ModuleLoad = response.Table;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onEdit(row: any) {
    console.log(row);
    this.Filter.WEBESSModuleMasterId = row.WEBESSModuleMasterId;
    this.Filter.FromDate = this.dateFormat.parse(row.FromDate);
    this.Filter.ToDate = this.dateFormat.parse(row.ToDate);
    this.Filter.Message = row.Message;
    this.Filter.ESS_ModuleLockConfigurationId = row.ESS_ModuleLockConfigurationID;
    this.Filter.IsRestrictedForAdmin = row.IsRestrictedforAdmin;
  }
}
